
// import React from 'react'
// import { useTranslation } from 'next-i18next'
import style from "../../../styles/mystyle.module.css";
// import Link from "@mui/icons-material/Link";
import Twitter from "@mui/icons-material/Twitter";
import Telegram from "@mui/icons-material/Telegram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import Facebook from "@mui/icons-material/Facebook";
import WhatsApp from "@mui/icons-material/WhatsApp";
import { useRouter } from "next/router";
import { grey } from "@mui/material/colors";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    // PinterestShareButton,
    // VKShareButton,
    WhatsappShareButton
    
  } from "next-share";
import * as config from "../../../next.config.js";
import { printLogs } from '../../helpers/helpers';
  
export default function share(props) {
  //  const {t}=useTranslation("common") 
   const router = useRouter();
  //  printLogs(" router.asPath", props)
    return (
        <div className={style.card}>
        <div className={style.cardssocail}>
          <div className={style.card}>
            <LinkedinShareButton
              url={String(config.env.baseUrl + router.asPath)}
             quote={props.title}
            >
              <LinkedIn sx={{ color: grey[500] }} className={style.iconPhone} />
            </LinkedinShareButton>
          </div>

          <div className={style.card}>
            <FacebookShareButton
              url={String(config.env.baseUrl + router.asPath)}
              quote={props.title}
            >
              <Facebook sx={{ color: grey[500] }} className={style.iconPhone} />
            </FacebookShareButton>
          </div>
          <div className={style.card}>
            <TelegramShareButton
              url={String(config.env.baseUrl + router.asPath)}
              quote={props.title}
            >
              <Telegram sx={{ color: grey[500] }}  className={style.iconPhone}/>
            </TelegramShareButton>
          </div>

          <div className={style.card}>
            <TwitterShareButton
              url={String(config.env.baseUrl + router.asPath)}
              quote={props.title}
            >
              <Twitter sx={{ color: grey[500] }} className={style.iconPhone} />
            </TwitterShareButton>
          </div>
          <div className={style.card}>

              
          <WhatsappShareButton
            url={String(config.env.baseUrl + router.asPath)}
            quote={props.title}
          >
            <WhatsApp sx={{ color: grey[500] }}  className={style.iconPhone} />
          </WhatsappShareButton>

           
          </div>
        </div>
      </div>
        


    
    )
}
